import {
  ADD_CONDITION,
  TOGGLE_COLUMN,
  CLEAR_ALL,
  RESET,
  UPDATE_COLUMNS,
} from '../actions'
import { ColumnAction } from '../actions'

export const getColumnNames = (latestPlan: boolean, earlyAccess: boolean) => {
  if (earlyAccess && latestPlan) {
    return COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS
  } else {
    return COLUMN_NAMES_WITH_STATUS
  }
}

const COLUMN_NAMES_WITH_STATUS = {
  name: { label: '企業名', displayOrder: 0, selected: true, width: 240 },
  description: {
    label: '事業内容',
    displayOrder: 1,
    selected: true,
    width: 360,
  },
  tags: { label: 'タグ', displayOrder: 2, selected: true, width: 360 },
  type: { label: 'タイプ', displayOrder: 3, selected: true, width: 120 },
  country: {
    label: '国・地域',
    displayOrder: 4,
    selected: true,
    width: 128,
  },
  established: {
    label: '設立年月日',
    displayOrder: 5,
    selected: true,
    width: 104,
  },
  representativeName: {
    label: '代表者名',
    displayOrder: 6,
    selected: true,
    width: 160,
  },
  employees: {
    label: '従業員数',
    displayOrder: 7,
    selected: true,
    width: 96,
  },
  state: { label: '都道府県', displayOrder: 8, selected: false, width: 96 },
  address: { label: '住所', displayOrder: 9, selected: false, width: 256 },
  telephone: {
    label: '電話番号',
    displayOrder: 10,
    selected: false,
    width: 128,
  },
  industry: { label: '業種', displayOrder: 11, selected: false, width: 216 },
  origin: { label: '起源', displayOrder: 12, selected: false, width: 160 },
  institute: {
    label: '大学・研究機関',
    displayOrder: 13,
    selected: false,
    width: 176,
  },
  website: {
    label: 'ウェブサイト',
    displayOrder: 14,
    selected: false,
    width: 200,
  },
  corporateNumber: {
    label: '法人番号',
    displayOrder: 15,
    selected: false,
    width: 136,
  },
  latestInitialSeries: {
    label: 'スピーダ\n調達シリーズ',
    displayOrder: 16,
    selected: true,
    width: 128,
  },
  cbLatestRoundType: {
    label: 'Crunchbase\n最新ラウンドタイプ',
    displayOrder: 17,
    selected: true,
    width: 160,
  },
  lastFundraised: {
    label: '最新ラウンド調達日',
    displayOrder: 18,
    selected: true,
    width: 152,
  },
  totalFunding: {
    label: '総調達額',
    displayOrder: 19,
    selected: true,
    width: 112,
  },
  totalFundingUpdated: {
    label: '総調達額算出日',
    displayOrder: 20,
    selected: false,
    width: 112,
  },
  valuation: {
    label: '調達後評価額',
    displayOrder: 21,
    selected: true,
    width: 120,
  },
  lastValuationDate: {
    label: '評価額算出ラウンド実施日',
    displayOrder: 22,
    selected: false,
    width: 168,
  },
  shareholderStatus: {
    label: '株主状況',
    displayOrder: 23,
    selected: true,
    width: 200,
  },
  investingStatus: {
    label: 'ステータス',
    displayOrder: 24,
    selected: true,
    width: 224,
  },
  investingStatusUpdated: {
    label: 'ステータス更新日',
    displayOrder: 25,
    selected: true,
    width: 144,
  },
  contactPerson: {
    label: '担当者',
    displayOrder: 26,
    selected: true,
    width: 144,
  },
  myLabels: {
    label: 'マイラベル',
    displayOrder: 27,
    selected: true,
    width: 340,
  },
  firstInterviewDate: {
    label: '初回面談日',
    displayOrder: 28,
    selected: true,
    width: 144,
  },
  sourcingRoute: {
    label: 'ソーシングルート',
    displayOrder: 29,
    selected: true,
    width: 224,
  },
  memo: { label: 'メモ', displayOrder: 30, selected: true, width: 336 },
  ipoCategory: {
    label: 'IPO区分',
    displayOrder: 31,
    selected: false,
    width: 120,
  },
  ipoJikasougaku: {
    label: 'IPO時 時価総額（初値）',
    displayOrder: 32,
    selected: false,
    width: 160,
  },
  // ipoJikasougakuPublicPrice: {
  //   label: 'IPO時 時価総額（公開価格）',
  //   displayOrder: 33,
  //   selected: false,
  //   width: 176,
  // },
  ipoed: { label: 'IPO年月日', displayOrder: 34, selected: false, width: 104 },
  market: {
    label: 'IPO市場',
    displayOrder: 35,
    selected: false,
    width: 160,
  },
  researchStatus: {
    label: '調査状況',
    displayOrder: 36,
    selected: false,
    width: 160,
  },
  updated: { label: '更新日', displayOrder: 37, selected: true, width: 96 },
  created: { label: '登録日', displayOrder: 38, selected: true, width: 96 },
}

export const COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS = {
  ...COLUMN_NAMES_WITH_STATUS,
}

export type ColumnName = keyof typeof COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS

export const UNREMOVABLE_NAMES = ['name']

export type ColumnState = {
  setting: ColumnName[]
}

// NOTE: この初期値は COLUMN_NAMES_WITH_STATUS から生成した方がよい
export const initialColumns: ColumnName[] = [
  'name',
  'description',
  'tags',
  'latestInitialSeries',
  'investingStatus',
  'investingStatusUpdated',
  'firstInterviewDate',
  'contactPerson',
  'memo',
  'representativeName',
  'totalFunding',
  'valuation',
  'state',
  'established',
  'lastFundraised',
  'type',
  'created',
  'updated',
]

const init: ColumnState = {
  setting: initialColumns,
}

export const toggle = (
  selected: ColumnName[],
  name: ColumnName
): ColumnName[] =>
  selected.includes(name)
    ? selected.filter((n) => n !== name)
    : [...selected, name]

export const add = (selected: ColumnName[], name: ColumnName) =>
  selected.includes(name) ? selected : [...selected, name]

export default function column(
  state: ColumnState = init,
  action: ColumnAction
) {
  switch (action.type) {
    case ADD_CONDITION:
      // researchStatusCategoryはDBには値を持っておらず、ロジック側でまとめているので、選択レコードとしては代替としてresearchStatusを利用する
      if (action.payload === 'researchStatusCategory') {
        return { ...state, setting: add(state.setting, 'researchStatus') }
      }
      return { ...state, setting: add(state.setting, action.payload) }
    case TOGGLE_COLUMN:
      return { ...state, setting: toggle(state.setting, action.payload) }
    case UPDATE_COLUMNS:
      // validate column names.
      const columnNames = action.payload as string[]
      const validColumnNames = Object.keys(
        COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS
      )
      const validatedColumnNames = columnNames.filter((name) =>
        validColumnNames.includes(name)
      )
      return { ...state, setting: validatedColumnNames }
    case CLEAR_ALL:
      return { ...state, setting: UNREMOVABLE_NAMES }
    case RESET:
      return { ...state, setting: action.payload }
  }
  return state
}
